import { PIEVE_AUTO_MODEL_ID } from './modelCatalog.js';

export const DEFAULT_PIEVE_MODEL_ID = PIEVE_AUTO_MODEL_ID;
export const DEFAULT_PIEVE_REASONING_EFFORT = 'high';
